import React, { useEffect, useState } from "react";
import { StarRating, CtaButton } from "./common";
import { BUSINESS } from "../mock";

export const Announcement = () => (
  <div className="w-full bg-brand-sage py-2.5 text-center">
    <p className="font-sans text-[13px] font-medium tracking-wide text-brand-ivory">
      {BUSINESS.announcement}
    </p>
  </div>
);

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const accent = BUSINESS.accent || "";
  const nameMain = accent && BUSINESS.name.endsWith(accent)
    ? BUSINESS.name.slice(0, BUSINESS.name.length - accent.length).trim()
    : BUSINESS.name;
  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-brand-ivory/90 shadow-sm backdrop-blur-md" : "bg-brand-ivory"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 md:px-8">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-full border border-brand-gold">
            <span className="font-serif text-lg font-semibold text-brand-sage">{BUSINESS.monogram}</span>
          </div>
          <span className="font-serif text-lg tracking-wide text-brand-ink md:text-xl">
            {nameMain} {accent && <span className="text-brand-sage">{accent}</span>}
          </span>
        </div>
        <div className="flex items-center gap-5">
          <div className="hidden items-center gap-2 md:flex">
            <StarRating size={14} />
            <span className="font-sans text-sm font-semibold text-brand-ink">{BUSINESS.rating}</span>
            <span className="font-sans text-sm text-brand-muted">· {BUSINESS.reviewCount} Google reviews</span>
          </div>
          <CtaButton size="sm" toForm>Claim My Spot</CtaButton>
        </div>
      </div>
    </header>
  );
};
